const rdimsState = {
  selectedRdims: {},
  selectedIndex: null
  // isViewMyLocks: false,
  // selectedRowStatus: ''
};

export default rdimsState;
